module.exports = __webpack_public_path__ + "static/media/ReadySitGo.9db60596.ico";